import { mapState, mapActions } from 'vuex'
import createApp from 'createApp'
const quotationHomeJumbo = () => import('Components/CategoryQuotation/quotationHomeJumbo.vue')
const quotationHomeHowItWorks = () => import('Components/CategoryQuotation/quotationHomeHowItWorks.vue')
const quotationHomeShelf = () => import('Components/CategoryQuotation/quotationHomeShelf.vue')
const quotationHomeShelfBox = () => import('Components/CategoryQuotation/quotationHomeShelfBox.vue')
const lpClients = () => import('Components/Landing/LandingPage/lpClients.vue')
const categorySupplier = () => import('Components/CategoryDirectory/categorySupplier.vue')
import quotationStep from 'Enums/quotationStep'
import { parse as parseUrl } from 'url'
import { parse as parseQuery } from 'qs'

createApp({
  components: {
    quotationHomeJumbo,
    quotationHomeHowItWorks,
    quotationHomeShelf,
    quotationHomeShelfBox,
    lpClients,
    categorySupplier,
  },
})